import type { GameSummary } from '@runtime/core/store/appStoreTypes'
import type { GameHistoryEntry } from './userModel'

/** The player index belongs to the attempt, never to whichever profile logs in later. */
export function historyFromGameSummary(
  summary: GameSummary,
): GameHistoryEntry | null {
  const players = Array.isArray(summary.players) ? summary.players : []
  const meIndex = summary.meIndex
  if (
    meIndex == null ||
    !Number.isInteger(meIndex) ||
    meIndex < 0 ||
    !players[meIndex] ||
    summary.id == null ||
    typeof summary.timestamp !== 'number'
  )
    return null
  const kind = summary.kind ?? 'classic'
  if (kind !== 'classic' && kind !== 'puzzle' && !kind.startsWith('strategy'))
    return null
  const me = players[meIndex]
  const winning = Array.isArray(summary.winningPlayerIndexes)
    ? summary.winningPlayerIndexes
    : null
  const isDraw =
    typeof summary.isDraw === 'boolean'
      ? summary.isDraw
      : winning
        ? winning.length === 0
        : summary.winnerIndex == null
  const isWin =
    !isDraw &&
    (winning ? winning.includes(meIndex) : summary.winnerIndex === meIndex)
  const groups = Array.isArray(summary.resultGroups) ? summary.resultGroups : []
  const ownGroup = groups.find((group) =>
    group.memberPlayerIndexes?.includes(meIndex),
  )
  const ownIndexes = new Set(ownGroup?.memberPlayerIndexes ?? [meIndex])
  const opponents = players
    .filter((_, index) => !ownIndexes.has(index))
    .map((player) => player.name)
    .filter(
      (name): name is string => typeof name === 'string' && name.length > 0,
    )
  const scoreFor = ownGroup?.score ?? me.score ?? null
  const scoreAgainst =
    ownGroup && groups.length === 2
      ? (groups.find((group) => group !== ownGroup)?.score ?? null)
      : players.length === 2
        ? (players[1 - meIndex]?.score ?? null)
        : null
  return {
    id: String(summary.id),
    ts: summary.timestamp,
    kind,
    grid: summary.grid,
    vsAI: !!summary.vsAI,
    myName: me.name,
    opponents,
    result: isDraw ? 'draw' : isWin ? 'win' : 'loss',
    scoreFor,
    scoreAgainst,
    durationMs: ownGroup?.timeMs ?? me.timeMs,
  }
}
